import CircleDiagram from '@/components/circle-diagram/circle-diagram.vue'
import Loader from '@/components/loader/loader.vue'
import defineManufactureMainPageMixin from '../mixins/define-manufacture-main-page'
import TableCustomSort from '@/components/table-custom-sort/table-custom-sort'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'TardinessStat',
  /**
   * метод goMainPage(manufacture_id), onContextmenuOrder(manufacture_id)
   */
  mixins: [ defineManufactureMainPageMixin ],
  components: {
    CircleDiagram,
    Loader,
    TableCustomSort
  },
  props: {
    tardinessInfo: {
      /**
       * "manufacture_id": 0,
       * "title": "Южное шоссе",
       * "all_count": 60,
       * "tardiness_count": 3,
       * "tardiness_percent": 5,
       * "is_critical": true
       */
      manufactures: [],
      total: {
        all_count: 0,
        tardiness_count: 0,
        tardiness_percent: 0
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      table: {
        columns: [
          {
            field: 'title'
          },
          {
            field: 'tardiness_count',
            type: 'number'
          },
          {
            field: 'tardiness_percent',
            type: 'number'
          },
          {
            field: 'tardiness_median',
            type: 'number'
          }
        ]
      }
    }
  },
  computed: {
    labelPluralaziton() {
      if (this.tardinessInfo.total && this.tardinessInfo.total.tardiness_count) {
        const tardinessCount = this.tardinessInfo.total.tardiness_count
        if (tardinessCount >= 10 && tardinessCount <= 20) {
          return 'опозданий'
        }
        const remainder = tardinessCount % 10
        if (remainder === 1) {
          return 'опоздание'
        }
        if (remainder >= 2 && remainder <= 4) {
          return 'опоздания'
        }      
      }
      return 'опозданий'
    }
  },
  methods: {
    numberWithSeparator
  }
}